import { type ComponentType } from "react";

import AccessorialImporter from "../accessorial-importer/accessorial-importer";
import ContactsImporter from "../contacts-importer/contacts-importer";
import CrownChargesValidator from "../crown-charges-validator/crown-charges-validator";
import DriversImporter from "../drivers-importer/drivers-importer";
import OrdersImporter from "../orders-importer/orders-importer";
import TariffSection from "./tariff/tariff-section";
import UsersImporter from "../users-importer/users-importer";

/**
 * A single importable Crown data module surfaced in the import hub.
 */
export type CrownModule = {
  /** URL path segment for the module's route. */
  path: string;
  /** Human-readable label shown in navigation. */
  label: string;
  /** The reusable importer/validator component rendered for the module. */
  component: ComponentType;
};

/**
 * Registry of Crown data import modules. Each entry maps a route path and
 * label to the reusable component that renders the importer or validator.
 */
export const CROWN_MODULES: CrownModule[] = [
  { path: "tariff", label: "Tariffs", component: TariffSection },
  {
    path: "accessorial",
    label: "Accessorials",
    component: AccessorialImporter,
  },
  { path: "orders", label: "Orders", component: OrdersImporter },
  { path: "users", label: "Users", component: UsersImporter },
  { path: "drivers", label: "Drivers", component: DriversImporter },
  { path: "contacts", label: "Contacts", component: ContactsImporter },
  {
    path: "charges-validator",
    label: "Charges Validator",
    component: CrownChargesValidator,
  },
];
